import { useState, useEffect, useContext } from 'react'
import { useLocation } from 'react-router-dom'

import { useAppContext } from '@at/sauron-platform-core'
import { OdsTypeWhiteList } from '@at/sauron-tracking/lib/utils/ods-legacy'
import { parse } from 'query-string'
import { UserLocationContext } from '../contexts/user-location-context'
import { useChannel } from './use-abtest.hook'

interface ODSAdvertData {
    advertId: string
    retailerId?: string | null
}

export const useODSData = ({ advertId, retailerId }: ODSAdvertData): OdsTypeWhiteList => {
    const { postcode } = useContext(UserLocationContext)

    const [odsData, setODSData] = useState<OdsTypeWhiteList>({})
    const { search } = useLocation()
    const channel = useChannel()

    const {
        config: { desktopView },
    } = useAppContext()

    const queryParams = parse(search)
    const searchContext = queryParams.journey ? String(queryParams.journey) : undefined

    useEffect(() => {
        setODSData({
            publicReference: advertId,
            sellerId: retailerId || '',
            postcode,
            channel,
            context: searchContext || 'NATURAL_SEARCH_JOURNEY',
            deviceUsed: desktopView ? 'desktop' : 'mobile',
        })
    }, [retailerId, channel, desktopView, searchContext, postcode, advertId])

    return odsData
}
